//import React from "react";
import React, { useEffect, useState } from "react";
import AdminS from "layouts/AdminS";
import Footer from "components/Footer/Footer";
import Swal from "sweetalert2";

// import { ToastContainer,toast, Zoom, Bounce } from 'react-toastify';
// import "react-toastify/dist/ReactToastify.css";
// import axios from "axios"
// import validator from 'validator'
import {
  Badge,
  Button,
  Card,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col,
  Table,
  DropdownButton,
  Dropdown,
  FormControl,
} from "react-bootstrap";

import firebase from "../firebase";

const UpdateAccDetails=(props)=> {

//Stroring Reteriwing Data
const [emailError, setEmailError] = useState(true) 
const[userData,setUserData]= useState([]);
const [company, setCompany] = useState("");
const [nic, setNIC] = useState("");
const [email, setEmail] = useState("");
const [firstname, setFirstName] = useState("");
const [lastname, setLastName] = useState("");
const [address, setAddress] = useState("");
const [city, setCity] = useState("");
const [country, setCountry] = useState("");
const [age, setAge] = useState("");
const [aboutme, setAboutme] = useState("");
const [id, setID] = useState("");
console.log(id);

 useEffect(()=>{

 setID(props.match.params.id)
 const files = firebase.database().ref("reqforaprooval").child(props.match.params.id);
  files.on('value', (snapshot)=>{
    const dataList = snapshot.val();
    setCompany(dataList.Company);
    setNIC(dataList.NIC);
    setEmail(dataList.Email);
    setFirstName(dataList.FirstName);
    setLastName(dataList.LastName);
    setAddress(dataList.Address);
    setCity(dataList.City);
    setCountry(dataList.Country);
    setAge(dataList.Age);
    setAboutme(dataList.AboutMe);
  }) 


 },[]);

 const updateData = (e) => {
  // var email = aEmail;    
    
  //     if (validator.isEmail(email)) {
  //       setEmailError(false);
  
          console.log(props.match.params.id)
          const files = firebase.database().ref("reqforaprooval").child(props.match.params.id);
          
          let data = {
            Company:company,
            NIC:nic,
            Email:email,
            FirstName:firstname,
            LastName:lastname,
            Address:address,
            City:city,
            Country:country,
            Age:age,
            AboutMe:aboutme,
          };
          files.update(data);
          alert("Succfully Updated");
          setCompany("");
          setNIC("");
          setEmail("");
          setFirstName("");
          setLastName("");
          setAddress("");
          setCity("");
          setCountry("");
          setAge("");
          setAboutme("");

//   else {
//     setEmailError(false);
//     Swal.fire(
//       'Email Address?',
//       'Invalid Email address',
//       'warning'
//     )  
// }
 }
//  const successToast = () => {
//   toast("Updating",{
//   //className: "custom-toast",
//   draggable: true,
//   position: toast.POSITION.TOP_CENTER,
//   progressClassName: 'success-progress-bar'
//   });
//   };

  // toast.success("SUCCESESFULLY UPDATED");
    return (
        <>
        <AdminS/>

<br/>


<Container>

  <Row>
    <Col md={{ span: 12, offset: 1 }}>  

      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">Update Account Details</Card.Title>
                <Form className="d-flex">
     
    </Form>
              </Card.Header>
              <Card.Body>
                <Form>
                  <Row>
                    <Col className="pr-1" md="5">
                      <Form.Group>
                        <label>Company</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="company"
                          type="text"
                          focus value = {company} onChange={(e)=>{setCompany(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="px-1" md="3">
                      <Form.Group>
                        <label>NIC</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="NIC"
                          type="number"
                          focus value = {nic} onChange={(e)=>{setNIC(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label htmlFor="exampleInputEmail1">
                            Email
                        </label>
                        <Form.Control
                          placeholder="Email"
                          type="text"
                          focus value = {email} onChange={(e)=>{setEmail(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pr-1" md="6">
                      <Form.Group>
                        <label>First Name</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="First Name"
                          type="text"
                          focus value = {firstname} onChange={(e)=>{setFirstName(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="6">
                      <Form.Group>
                        <label>Last Name</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="Last Name"
                          type="text"
                          focus value = {lastname} onChange={(e)=>{setLastName(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>Address</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="Address"
                          type="text"
                          focus value = {address} onChange={(e)=>{setAddress(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label>City</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="City"
                          type="text"
                          focus value = {city} onChange={(e)=>{setCity(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label>Country</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="Country"
                          type="text"
                          focus value = {country} onChange={(e)=>{setCountry(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>

                    <Col className="pl-1" md="4">
                      <Form.Group>
                        <label>Age</label>
                        <Form.Control
                          defaultValue=""
                          placeholder="Age"
                          type="number"
                          focus value = {age} onChange={(e)=>{setAge(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    
                  </Row>
                  
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <label>About Me</label>
                        <Form.Control
                          cols="80"
                          defaultValue=""
                          placeholder="Description about Transprt manager"
                          rows="4"
                          as="textarea"
                          focus value = {aboutme} onChange={(e)=>{setAboutme(e.target.value);}}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  {/* <ToastContainer /> */}
                  <Button onClick={(e)=>{updateData();}} variant="primary" size="" active>
                  Update
                </Button>{' '}

                </Form>
              </Card.Body>
            </Card>
          </Col>
          
        </Row>
      </Container>
      </Col>
  </Row>

  
</Container>


<Footer /> 
    </>

     ) ;
    }



export default UpdateAccDetails;